<template>
  <q-card style="max-width: 400px; width: 100%; background-color: transparent" flat>
    <q-card-section v-if="showTitle" class="q-pa-none q-pb-md">
      <div class="text-h5">{{ formTitle || 'Chat Form' }}</div>
    </q-card-section>
    <q-separator v-if="showTitle" />

    <!-- Chat Messages Preview -->
    <div class="chat-preview-container q-pt-md">
      <section v-for="(message, key) in previewMessages" :key="key">
        <q-chat-message
          :avatar="message.sent ? avatarUrl : noAvatarUrl"
          :name="message.sent ? 'あなた' : 'Bot'"
          :text="[message.text]"
          :sent="message.sent"
          :bg-color="message.sent ? 'positive' : 'white'"
          v-if="message.type === 'text'"
          class="fade-in-text"
        />
      </section>

      <!-- Show empty state if no messages -->
      <div v-if="previewMessages.length === 0" class="text-center text-grey-6 q-mt-lg">
        <div class="text-subtitle1">チャットメッセージが表示されます</div>
        <div class="text-caption">フォーム設問を追加すると、ここにプレビューが表示されます</div>
      </div>
    </div>
  </q-card>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { IFormDetail } from '@/utils/types'

@Options({
  components: {},
  emits: ['update:modelValue'],
})
export default class ChatPreview extends Vue {
  @Prop({ default: () => [] })
  formFields!: IFormDetail[]

  @Prop({ default: '' })
  formTitle!: string

  @Prop({ default: true })
  showTitle!: boolean

  @Prop({ default: () => ({}) })
  modelValue!: Record<string, any>

  previewMessages: Array<{
    type: string
    text: string
    sent: boolean
    name?: string
  }> = []

  get avatarUrl() {
    return window.location.origin + '/img/default-user-avatar.png'
  }

  get noAvatarUrl() {
    return window.location.origin + '/img/default-user-avatar.png'
  }

  @Watch('formFields', { immediate: true, deep: true })
  onFormFieldsChange() {
    this.generatePreviewMessages()
  }

  generatePreviewMessages() {
    this.previewMessages = []

    if (!this.formFields || this.formFields.length === 0) {
      return
    }

    // Generate preview messages based on form fields
    this.formFields.forEach((field) => {
      if (field.field_name && field.field_name.trim() !== '') {
        this.previewMessages.push({
          type: 'text',
          text: field.field_name,
          sent: false,
          name: 'Bot',
        })

        this.previewMessages.push({
          type: 'text',
          text: field.option_type as string,
          sent: true,
        })
      }
    })
  }
}
</script>

<style scoped lang="scss">
.chat-preview-container {
  overflow-y: auto;

  :deep(.q-message-avatar) {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
  }
}

.fade-in-text {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
